const apiPlatformResponseViolationsParser = (violations) => {
  let errors = {};

  if(violations){
    violations.map(violation => {
      if(!errors[violation.propertyPath]){
        errors[violation.propertyPath] = [];
      }
      errors[violation.propertyPath].push(violation.message);
    });
  }

  return errors;
}

export default apiPlatformResponseViolationsParser;
